import 'css-chunksrc/client/scenes/preferences/activityReport/styles.scss';export default {
  "activityReport": "_activityReport_1paeh_1",
  "explanation": "_explanation_1paeh_5",
  "group": "_group_1paeh_12",
  "checkbox": "_checkbox_1paeh_21",
  "formWrapper": "_formWrapper_1paeh_26",
  "label": "_label_1paeh_35",
  "button": "_button_1paeh_42"
};